import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutPixelParams, checkoutUrl, price } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Always-visible purchase shortcut on small screens: appears after the hero
 * and hides over the offer section. Visibility uses IntersectionObserver, so
 * it never forces a synchronous reflow on scroll.
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('offer');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-navy px-4 py-3 transition-[opacity,transform] duration-200 ease-out sm:hidden ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-224" data-mp="gvp2wbyjj0cy">
      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', checkoutPixelParams)} className="flex w-full items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-cta px-6 py-3.5 font-display text-lg font-bold uppercase leading-none tracking-wide text-on-accent transition-colors duration-150 ease-out hover:bg-cta-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cta" data-id="element-225" data-mp="pv2bl2eubkwm">
        Get full access now — {price}
        <ArrowRightIcon className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" data-id="element-226" data-mp="2wo4thcnlcgje" />
      </a>
    </div>;
}